import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  box: {
    ...dFlex(),
    flexDirection: 'column',
    gap: 24,
    color: theme.primary.p2,
    flexGrow: 1,

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      flexGrow: 'initial',
      display: 'block',
      paddingRight: 2,
    },
  },
  title: {
    marginRight: 'auto',
  },
  btnBox: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    width: '100%',

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gridTemplateColumns: '1fr',
    },
  },
  content: {
    height: '100%',
    width: '100%',
    flexDirection: 'column',
    ...dFlex('space-between'),
    gap: 24,
    zIndex: 10,

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      height: 'fit-content',
      paddingTop: 24,
    },
  },
  maxCount: {
    paddingTop: 24,
  },
  selectedTableBox: {
    display: 'grid',
    gap: 24,
    width: '100%',
  },
  allFarms: {
    width: '100%',
  },
  filters: {
    [theme.breakpoints.down(Breakpoint.Sm)]: {
      display: 'grid',
      gridTemplateRows: 'auto',
      gridTemplateColumns: 'repeat(12, 1fr)',

      '& >:nth-of-type(1)': {
        gridColumn: 'span 12',
        order: 'initial !important',
      },

      '& >:nth-of-type(2)': {
        gridColumn: 'span 12',
        order: 'initial !important',
      },

      '& >:nth-of-type(3)': {
        gridColumn: 'span 6',
        order: 'initial !important',
      },

      '& > :nth-of-type(4)': {
        gridColumn: 'span 6',
        order: 'initial !important',
      },

      '& > :nth-of-type(5)': {
        gridColumn: 'span 12',
        order: 'initial !important',
      },
    },
  },
}));

export default useStyles;
